import React from 'react';
import { useRecoilValue } from 'recoil';
import { IButton, ILabel } from '../../../../../../utils/types/contentful';
import { formatContentfulComponentProps } from '../../../../../utils/globals';
import {
  productState,
  variantState,
} from '../../../../../utils/recoil/product';
import { ProductMainColorPicker } from './ColorPicker/productMainColorPicker';
import { ProductMainDiopterPicker } from './DiopterPicker/ProductMainDiopterPicker';
import { ProductMainSizePicker } from './SizePicker/ProductMainSizePicker';
import { ShapePicker } from '../Pack/ShapesPicker/ProductPackShapesPicker';

export interface ProductPackVariantDetailsProps {
  label: ILabel;
  subLabel: ILabel;
  button: IButton;
}

export const ProductPackVariantSelectorDetails: React.FC<
  ProductPackVariantDetailsProps
> = ({ colorPicker, diopterPicker, sizePicker, category, idx }) => {
  const product = useRecoilValue(productState);
  const variant = useRecoilValue(variantState);

  if (!product) {
    return <></>;
  }

  return (
    <div className='flex-1 overflow-scroll no-scrollbar'>
      <div className='mx-4 mt-4 p-6 border border-black'>
        {colorPicker && (
          <ProductMainColorPicker
            variants={product.variants}
            productSize={variant.size?.value}
            selectedColor={variant.color}
            labelDetails={variant?.labelDetails}
            {...formatContentfulComponentProps(colorPicker)}
          />
        )}
        {diopterPicker && (
          <ProductMainDiopterPicker
            variant={variant}
            category={category}
            {...formatContentfulComponentProps(diopterPicker)}
          />
        )}
        {sizePicker && product.sizes && (
          <ProductMainSizePicker
            variant={variant}
            sizes={product.sizes}
            category={category}
            {...formatContentfulComponentProps(sizePicker)}
          />
        )}
      </div>

      <ShapePicker
        idx={idx}
        shapeIndex={idx}
        shapeProduct={product}
        productsLength={1}
      />
    </div>
  );
};
